var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 16.1054C12.949 16.1054 13.7656 15.5917 14.3263 14.844C14.8869 14.0966 15.2173 13.0892 15.2173 11.9999C15.2173 10.9106 14.8869 9.90318 14.3263 9.15573C13.7656 8.40812 12.949 7.89434 12.0007 7.89434C11.0523 7.89434 10.2357 8.40812 9.67503 9.15573C9.11445 9.90318 8.78398 10.9106 8.78398 11.9999C8.78398 13.0892 9.11445 14.0966 9.67503 14.844C10.2357 15.5917 11.0523 16.1054 12.0007 16.1054Z",
    stroke: "#0B1641",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.9297C14.8233 19.6104 13.4571 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.1035 19.7766 14.1548 19.3725 15.1111C18.9685 16.0675 17.905 16.1698 16.8889 16C15.6784 15.7977 14.6667 13.7778 14.6667 13.7778",
    stroke: "#0B1641",
    strokeWidth: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.d9691b75b12134dc053fcac221cb7352.svg";
export { ForwardRef as ReactComponent };